// Librairies importés.
import ref from 'vue';
import { Component, Watch, Vue,} from 'vue-property-decorator';
import { Getter } from 'vuex-class';

// Services.
import { SecurityService } from '@/security/SecurityService';
import utilisateurProducteurService from '@/services/utilisateurProducteur/UtilisateurProducteurService';

// Stores.
import { SecurityStoreMethods } from '@/store/security/SecurityStore';

// Modèles.
import { UserInfo } from '@/shared/models/UserInfo.model';

// Énumérations.
import { Role } from '@/shared/enums/Role.enum';

// Component.
import { AppLauncherOktaB2B } from '@engie-ec/app-launcher-okta-b2b';

// Modèles.
import UserApplication from '@engie-ec/app-launcher-okta-b2b/types/models/UserApplication';

// Configuration.
import { GlobalConfiguration } from '@/shared/GlobalConfiguration';
import { getMaxListeners } from 'cluster';

import { CoreHelper } from '@/shared/helpers/CoreHelper';

/**
 * Composant d'affichage du menu.
 */
@Component
export default class NavMenuComponent extends Vue {

    public $refs: { 
        appLauncher: AppLauncherOktaB2B;
     };
    /**
     * L'utilisateur connecté.
     */
    @Getter(SecurityStoreMethods.GET_USERINFO)
    public utilisateurCourant: UserInfo;

    /**
     * L'environnement de l'application.
     */
    public environnement: string = GlobalConfiguration.environmentName;

    /**
     * L'URL de l'application web (front) GESGO.
     */
    public gesgoUrl: string = CoreHelper.Sanitize(GlobalConfiguration.gesgoUrl);

    /**
     * Le service générique pour les appels api
     */
    private utilisateurProducteurService = new utilisateurProducteurService();

    /**
     * La liste des applications Okta de l'utilisateur.
     */
    public utilisateurApplication = new ref<UserApplication[]>([]);

    @Getter(SecurityStoreMethods.GET_IS_USER_ADMIN) public isAdmin: boolean;
    
    /**
     * Déclenche la déconnexion de l'utilisateur courant.
     */
    public logout() {
        return SecurityService.logout();
    }

    @Watch('utilisateurCourant')
    public async updateListApplicationUtilisateur() {
        await this.getListApplicationOkta().then(
            (result) => {
                this.$refs.appLauncher.userApplications = result.data.data;
            }
        );
    }

    /**
     * Récupère la liste des applications Okta de l'utilisateur.
     */
    private async getListApplicationOkta() {
        return this.utilisateurProducteurService.getListApplicationOkta()
    }

}
